<template>
  <Select
    :placeholder="placeholder"
    :options="cityList"
    :is-no-results="isNoResults"
    :value="value"
    @search="onInput"
    @change="onChangedValue"
  />
</template>

<script>
import { debounce } from 'lodash';
import axios from 'axios';
import Select from '@/components/UiKit/v2/Select/index.vue';

export default {
  name: 'CityInput',
  components: {
    Select
  },
  props: {
    placeholder: {
      type: String,
      default: 'Выберите местоположение'
    },
    value: {
      type: String,
      required: true
    }
  },
  data: () => ({
    cityList: [],
    isNoResults: false,
    loadingData: false,
    dadataAPI: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
    DADATA_TOKEN: '9d9eb4a95be2894957a6c0b29d4bc11d39d8970a'
  }),
  computed: {
    options() {
      return this.cityList.length ? this.cityList : this.value ? [this.value] : [];
    }
  },
  created() {
    this.fetchSuggestionsDebounced = debounce(e => {
      this.fetchSuggestions(e);
    }, 500);
  },
  beforeDestroy() {
    this.fetchSuggestionsDebounced.cancel();
  },
  methods: {
    onChangedValue(event) {
      this.cityList = [];
      this.$emit('changedValue', event);
    },
    onInput(event) {
      this.fetchSuggestionsDebounced(event);
    },
    fetchSuggestions(input) {
      this.loadingData = true;
      axios({
        method: 'post',
        headers: {
          Authorization: 'Token ' + this.DADATA_TOKEN
        },
        url: this.dadataAPI,
        data: {
          query: input,
          count: 20,
          locations: [
            {
              country: '*'
            }
          ],
          from_bound: { value: 'city' },
          to_bound: { value: 'settlement' }
        }
      })
        .then(({ data }) => {
          if (data.suggestions.length) {
            this.cityList = data.suggestions.map(s => s.value);
            this.isNoResults = false;
          } else {
            this.cityList = [];
            this.isNoResults = true;
          }
          this.loadingData = false;
        })
        .catch(() => {
          this.loadingData = false;
        });
    }
  }
};
</script>
